<div class="landing">
  <!-- <div class="my-container">
    <h1>{{'This service is temporarily unavailable' | translate}}</h1>
  </div> -->
  <section id="banner">
    <div class="my-container banner background-white">

      <div class="left-side">
        <div class="text">
          <h1>{{'landing.description' | translate}}</h1>
          <p class="body1">{{'landing.description2' | translate}}</p>
        </div>
        <button class="btn btn-primary" *ngIf="!this.authService.isLoggedIn && !this.authService.isDeviceMobile"
                (click)="redirectToIdp()">{{ 'Login with Egov' | translate }}</button>
        <button class="btn btn-primary w-100" *ngIf="this.authService.isLoggedIn && this.authService.isDeviceMobile"
                routerLink="/">{{ 'GoToCabinetPwa' | translate }}</button>
      </div>
      <div class="landing-img">
        <img
          src="assets/img/landing-banner.png"
          [attr.alt]="'alt.landingBanner' | translate"
        />
      </div>
    </div>
  </section>

  <section id="advantages" class="advantages">
    <div class="my-container">
      <div class="row-landing">
        <div
          class="advantages-card"
          *ngFor="let card of advantages"
          [ngClass]="card.cardClass">
          <h2 class="landing-card-header">{{ card.titleKey | translate }}</h2>
          <div class="advantages-content">
            <div class="advantages-row" *ngFor="let item of card.items">
              <img
                [src]="item.icon"
                [attr.alt]="'alt.advantageIcon' | translate"
              />
              <p class="body1" [innerHTML]="item.textKey | translate"></p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  <section class="how-works my-container background-white" *ngIf="!authService.isDeviceMobile">
    <h2 id="how-works" class="font-weight-bold howItWorks landing-card-header">{{'landing.howItWorks' | translate}}</h2>
    <div class="row-landing">
      <div class="howItWorksCard">
        <img
          src="assets/img/How-it-works1.png"
          [attr.alt]="'alt.howItWorksStep1' | translate"
        />
        <h3>{{'landing.Create a contract' | translate}}</h3>
      </div>
      <div class="howItWorksCard">
        <img
          src="assets/img/How-it-works2.png"
          [attr.alt]="'alt.howItWorksStep2' | translate"
        />
        <h3>{{'landing.Request for consent'| translate}}</h3>
      </div>
      <div class="howItWorksCard">
        <img
          src="assets/img/How-it-works3.png"
          [attr.alt]="'alt.howItWorksStep3' | translate"
        />
        <h3>{{'landing.Filling out a contract'| translate}}</h3>
      </div>
    </div>

  </section>
  <section id="faq" class="advantages mb-32" *ngIf="!authService.isDeviceMobile">
    <div class="my-container background-white" style="padding: 0 0 24px 0!important;">
      <h2 class="font-weight-bold landing-card-header">{{'landing.Faq' | translate}}</h2>
          <div class="faq-grid">
        <div *ngFor="let faq of faqs" class="landing-card" [class.open]="faq.show">
          <div class="question d-flex justify-content-between cursor-pointer text-left" (click)="click(faq)"
               [class.active]="faq.show">
            <h3>{{faq.question[currentLanguage]}}</h3>
            <img
              src="assets/icons/angle-down.svg"
              class="rec mr-2"
              [class.rotate]="faq.show"
              [attr.alt]="'alt.toggleFaq' | translate"
            />
          </div>
          <div class="answer" [class.show]="faq.show">
            <p *ngIf="faq.show" class="mx-5 mb-4 body2" [innerHTML]="faq.answer[currentLanguage]"></p>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-secondary" (click)="toggleAll()">
          {{showAll ? ('landing.hide' | translate) : ('landing.showMore' | translate)}}
        </button>
      </div>

    </div>
  </section>
</div>
